import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  capitalizeFirst,
  defaultToastError,
  defaultToastSuccess,
} from "App/utils/helpers";
import React, { useState } from "react";
import {
  RESET_STATE_MASTER_FORMULA_HARGA,
  useTarif,
  urlUpdate,
} from "./helpers";

function FormMasterFormulaHarga({ formData, setFormData, setNewData }) {
  const tarif = useTarif();
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChangePresentasi = (val, id) => {
    const jenisTarif = formData.jenisTarif;
    const objIndex = jenisTarif.findIndex((obj) => obj.tarif_id === id);
    jenisTarif[objIndex]["persentasi"] = val;
    setFormData({
      ...formData,
      jenisTarif,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const newJenisTarif = await convertToValidInput(formData.jenisTarif);
      const res = await instance4.post(urlUpdate, {
        harga_id: formData.harga_id,
        formula_id: formData.formula_id,
        jenisTarif: newJenisTarif,
      });
      if (res.data.status === 200) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastSuccess(res.data.message);
        await setNewData();
      } else {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(res.data.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  const convertToValidInput = async (arr) => {
    const temp = [];
    await arr.map((e) =>
      temp.push({
        id: e.id,
        tarif_id: e.tarif_id,
        persentasi: parseFloat(e.persentasi),
      })
    );

    return temp;
  };
  return (
    <div
      style={{
        padding: "1rem",
      }}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={6}>
            <InputTextMaster
              name='namaMsHarga'
              label='HARGA'
              id='namaMsHarga'
              value={formData.namaMsHarga}
              readOnly
              disabled
              placeholder='Harga'
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='namaFormula'
              label='FORMULA'
              id='namaFormula'
              value={formData.namaFormula}
              readOnly
              disabled
              placeholder='Formula'
            />
          </Grid>
          {tarif.map((row) => {
            const checked = formData.jenisTarif.filter(
              (e) => e.tarif_id === row.id
            );
            return (
              <Grid item sm={3}>
                <InputTextMaster
                  name={row.name}
                  label={row.name}
                  id={row.name}
                  value={checked[0]?.persentasi}
                  onChange={(e) =>
                    handleChangePresentasi(e.target.value, row.id)
                  }
                  placeholder={capitalizeFirst(row.name)}
                />
              </Grid>
            );
          })}
        </Grid>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              color='danger'
              name='Reset'
              size='md'
              onClick={() => setFormData(RESET_STATE_MASTER_FORMULA_HARGA)}
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.state}
              size='md'
            />
          </Grid>
        </div>
      </form>
    </div>
  );
}

export default FormMasterFormulaHarga;
